export const initialState = {
  authEmail: '',
}

export const setAuthEmail = (_state, payload) => (
  { authEmail: payload }
)
